const cacheBlackList = [
  '/me',
  '/login',
  '/login/otp',
  '/apple-auth',
  '/auth/app/callback',
  '/signup/otp',
  '/donation-banner',
  '/donate/auto',
  '/user/update-parameters-token',
]

/**
 * Indicates whether the given URL is blacklisted for caching
 *
 * @param url the URL to check
 * @returns {boolean} true if the URL is blacklisted, false otherwise
 */
export const isCacheBlackListed = (url: string) => cacheBlackList.some((value) => url.includes(value))
